import { UseQueryResult } from '@tanstack/react-query';
import { resolveError } from 'lib/utils/formatters/error/resolve-error';
import { UseErrorListReturn } from 'lib/utils/useErrorList';
import { useEffect } from 'react';

export function useQueryErrorNotifier(
  query: Pick<UseQueryResult, 'error'>,
  errorList: UseErrorListReturn,
  prefix?: string
) {
  useEffect(
    () => {
      if (query.error) {
        const error = resolveError(query.error);
        const newError = new Error(`${prefix}: ${error.message}`, {
          cause: error.cause
        });
        errorList.addError(newError);
      }
    },
    // eslint-disable-next-line
    [query.error, errorList.reset, errorList.addError, prefix]
  );
}
